import { Box, Typography } from "@mui/material";
import { getNewUpdateItem } from "api/services/automation/income-tax-tan";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { ResType } from "types";
import UpdatesForms from "./forms";
import AccessDenied from "../../Access/accessDenide";
import Loader from "components/Loader";
import UpdatesEchallan from "./eChallan";
import UpdatesMycas from "./myCas";
import UpdatesTraceCommunications from "./traceCommunication";
import UpdatesTempNoticeFya from "./tempNoticeFya";
import UpdatesTempNoticeFyi from "./tempNoticeFyi";
import UpdatesTraceDemand from "./traceDemand";

const TanUpdatesFullVIew = () => {
  const params = useParams();
  const { data, isLoading }: ResType = useQuery(["get-tan-form-data", params.id], getNewUpdateItem);
  if (isLoading) return <Loader />;
  return (
    <>
      {!data?.data && <AccessDenied />}
      {data?.data && (
        <Box m={1} height="75vh" overflow="auto" mb={3}>
          <Typography variant="h5" color="secondary" m={1}>
            Client Name: {data?.data?.client?.displayName}
          </Typography>
          <UpdatesForms forms={data?.data?.forms} />
          <UpdatesEchallan eChallan={data?.data?.eChallan} />
          <UpdatesMycas myCas={data?.data?.myCas} />
          <UpdatesTraceCommunications traceCommunication={data?.data?.traceCommunication} />
          <UpdatesTempNoticeFya eProceedingFya={data?.data?.tempNoticeFya} />
          <UpdatesTempNoticeFyi eProceedingFyi={data?.data?.tempNoticeFyi} />
          <UpdatesTraceDemand outstandingDemand={data?.data?.outstandingDemand}/>
        </Box>
      )}
    </>
  );
};

export default TanUpdatesFullVIew;
